var codeblock_default = {
  "blockStyleSpacing": "s8ouz",
  "codeBlock": "gu0MD s8ouz",
  "renderedInTable": "gsgoa"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
